
import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { CalsoftService } from 'src/app/services/Calsoft.service';
import { CommonService } from 'src/app/services/common.service';
import { SideNavService } from 'src/app/services/side-nav.service';



@Component({
  selector: 'calsoft-sidebar-menu-new',
  templateUrl: './sidebar-menu-new.component.html',
  styleUrls: ['./sidebar-menu-new.component.scss']
})
export class SidebarMenuNewComponent implements OnInit {
  @Input() menuItems:any=[];
  @Input() menuParentId=2;
  parentMenu:Array<any>;
  menuId: string;

  @Input() depth: number = 0;

  constructor(private sidenavMenuService:SideNavService,      public calsoftService: CalsoftService, private renderer: Renderer2,private commonService:CommonService, ) { }

  ngOnInit() {
    this.parentMenu = this.menuItems;
  }

  onClick(menuId,parentId,menu){
    this.sidenavMenuService.toggleMenuItem(menuId,parentId,menu);
    this.sidenavMenuService.closeOtherSubMenus(this.menuItems, menuId);    
  }


  toggleMenuItem(menuId: string) {
    let menuItem = document.getElementById('menu-item-' + menuId);
    let subMenu = document.getElementById('sub-menu-' + menuId);
  
    if (subMenu) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        this.renderer.removeClass(menuItem, 'expanded');
      } else {
        subMenu.classList.add('show');
        this.renderer.addClass(menuItem, 'expanded');
        this.menuId=menuId;
      }
    }
  }
  isExpanded(menuId: string): any {
    // Check if the menu item is expanded
    if(this.sidenavMenuService.expandedItems.findIndex(item => item === menuId)>=0) {
      return true;
    }else{
      return false;
    }
  }

  goToCategory(menu) {

    this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);
   this.calsoftService.sidenavOpen = false;

 }

}
